var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.696 10.0964C16.696 9.87552 16.5273 9.69643 16.3192 9.69643L4.20206 9.69643L8.82076 4.56406C8.96854 4.39985 8.95522 4.14693 8.79101 3.99916C8.6268 3.85138 8.37388 3.8647 8.2261 4.02892L3.00672 9.82878C2.86982 9.98089 2.86982 10.2118 3.00671 10.3639L8.2261 16.1641C8.37387 16.3283 8.62679 16.3416 8.791 16.1938C8.95521 16.0461 8.96854 15.7931 8.82077 15.6289L4.20218 10.4964L16.3192 10.4964C16.5273 10.4964 16.696 10.3173 16.696 10.0964Z",
    fill: "currentColor",
    transform: "rotate(90 10 10)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.d005d11fbab26cfbb7d07762233ac0ce.svg";
export { ForwardRef as ReactComponent };